<template>
  <!-- 修改密码 -->
  <el-dialog
    title="信息变更-密码修改"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content-wrap">
      <!-- 方式 -->
      <el-form label-width="120px">
        <el-form-item label="密码修改方式" required>
          <el-radio-group v-model="updatePassType" :disabled="codePassed">
            <el-radio :label="1">原有密码验证</el-radio>
            <el-radio :label="2">短信验证</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 原密码 -->
      <el-form
        v-if="updatePassType === 1"
        ref="byPassword"
        :model="byPasswordForm"
        label-width="120px"
        size="medium"
        class="byPasswordForm"
        :rules="rules"
        key="byPassword"
      >
        <el-form-item label="原有密码" prop="old_password">
          <el-input
            v-model.trim="byPasswordForm.old_password"
            maxlength="18"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model.trim="byPasswordForm.password"
            maxlength="18"
            show-password
          ></el-input>
          <p class="tips">8-18位字母、数字、字符、区分大小写</p>
        </el-form-item>
        <el-form-item label="再次输入密码" prop="re_password">
          <el-input
            v-model.trim="byPasswordForm.re_password"
            show-password
            maxlength="18"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 验证码1 -->
      <el-form
        v-if="updatePassType === 2 && !codePassed"
        label-width="120px"
        size="medium"
        class="byCodeForm"
        key="byCodeForm"
      >
        <el-form-item label="手机号" class="mobile-item">
          <p class="mobile">{{ user && user.mobile ? user.mobile : "" }}</p>
          <el-button type="text" @click="sendCode" :disabled="sending">{{
            buttonText
          }}</el-button>
        </el-form-item>
        <el-form-item label="请输入验证码">
          <el-input v-model.trim="code" maxlength="6"></el-input>
        </el-form-item>
      </el-form>
      <!-- 验证码2 -->
      <el-form
        v-if="codePassed && updatePassType === 2"
        ref="newPasswordForm"
        :model="newPasswordForm"
        label-width="120px"
        size="medium"
        class="newPasswordForm"
        :rules="newPasswordRules"
        key="newPasswordForm"
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model.trim="newPasswordForm.password"
            maxlength="18"
            show-password
          ></el-input>
          <p class="tips">8-18位字母、数字、字符、区分大小写</p>
        </el-form-item>
        <el-form-item label="再次输入密码" prop="re_password">
          <el-input
            v-model.trim="newPasswordForm.re_password"
            show-password
            maxlength="18"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="updatePassType === 1"
        type="primary"
        @click="submitByPassForm"
        v-preventReClick
        >提交</el-button
      >
      <el-button
        v-if="updatePassType === 2"
        type="primary"
        @click="submitByCodeForm"
        v-preventReClick
        >提交</el-button
      >
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sendCode } from "@saas/service-api/src/index.js";
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import { mapGetters } from "vuex";
import {
  updatePasswordByPwd,
  updatePasswordBySms,
} from "@saas/service-api/src/user-info/index";
export default {
  mixins: [ManMachineVerify],
  data: function () {
    var validatePass1 = (rule, value, callback) => {
      if (value !== this.byPasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.newPasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9\s]).{8,}$/;
      if (!regex.test(value)) {
        callback(
          new Error("密码必须至少8位，且包含数字、字母和至少一个特殊字符")
        );
      } else {
        callback();
      }
    };
    return {
      sending: false,
      dialogVisible: false,
      updatePassType: 1,
      byPasswordForm: {},
      newPasswordForm: {},
      code: "",
      buttonText: "获取验证码",
      buttonTimer: null,
      time: 60,
      codePassed: false,
      rules: {
        old_password: [{ required: true, message: "必填项", trigger: "blur" }],
        password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        re_password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass1, trigger: "blur" },
        ],
      },
      newPasswordRules: {
        password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        re_password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.buttonTimer);
  },
  methods: {
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      let params = {
        account: this.user.mobile,
        randstr: res.randstr,
        scene: "UpdatePassword",
        ticket: res.ticket,
      };
      this.sending = true;
      sendCode(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("验证码已发送");
            this.timer();
          } else {
            this.$message.error(res.message);
            this.sending = false;
          }
        })
        .catch(() => {
          this.sending = false;
        });
    },
    timer() {
      this.buttonTimer = setInterval(() => {
        if (this.time < 1) {
          clearInterval(this.buttonTimer);
          this.buttonText = "获取验证码";
          this.sending = false;
          this.time = 60;
        } else {
          this.time = this.time - 1;
          this.buttonText = `${this.time}s后重新发送`;
        }
      }, 1000);
    },
    sendCode() {
      // 发送验证码前需要人机验证
      this.showCaptcha();
    },
    submitByCodeForm() {
      if (this.codePassed) {
        this.$refs.newPasswordForm.validate((valid) => {
          if (valid) {
            let params = {
              ...this.newPasswordForm,
              account: this.user.mobile,
              code: this.code,
              is_verify: 2,
            };
            updatePasswordBySms(params).then((res) => {
              if (res.code === 1) {
                this.handleClose();
                this.$emit("success");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
      } else {
        if (!this.code) {
          this.$message.warning("请输入验证码");
          return false;
        }
        let params = {
          account: this.user.mobile,
          code: this.code,
          is_verify: 1,
        };
        updatePasswordBySms(params).then((res) => {
          if (res.code === 1) {
            this.codePassed = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    submitByPassForm() {
      this.$refs.byPassword.validate((valid) => {
        if (valid) {
          updatePasswordByPwd({ ...this.byPasswordForm }).then((res) => {
            if (res.code === 1) {
              this.handleClose();
              this.$emit("success");
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.sending = false;
      this.updatePassType = 1;
      this.byPasswordForm = {};
      this.newPasswordForm = {};
      this.code = "";
      this.buttonText = "获取验证码";
      if (this.buttonTimer) {
        clearInterval(this.buttonTimer);
        this.buttonTimer = null;
      }
      this.time = 60;
      this.codePassed = false;
      if (this.$refs["byPassword"]) {
        this.$refs["byPassword"].clearValidate();
      }
      if (this.$refs["newPasswordForm"]) {
        this.$refs["newPasswordForm"].clearValidate();
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="scss" scoped>
.content-wrap {
  .byPasswordForm .el-form-item {
    width: 500px;
  }
  .byCodeForm .mobile-item {
    ::v-deep .el-form-item__content {
      display: flex;
    }

    .mobile {
      width: 150px;
    }
  }
}
</style>
